import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "general-table__header-title general-table__header-title_align-right" }
const _hoisted_2 = { class: "general-table__header-title" }
const _hoisted_3 = { class: "general-table__header-title" }
const _hoisted_4 = { class: "general-table__header-title general-table__header-title_align-center" }

import { ElCol, ElRow } from 'element-plus';
import { ref, toRef } from 'vue';
import draggable from 'vuedraggable';
import { useI18n } from 'vue-i18n';
import GeneralTableRow from '@/components/Form/GeneralTableRow.vue';
import { MediaFile, Lang, DocumentTypeEnum, LinkRole } from '@/types/manuals';
import { UploadedPayloadType } from '@/utils/fileUploader';
import { reOrder } from '@/router/Admin/builderManuals';


export default /*@__PURE__*/_defineComponent({
  __name: 'GeneralTable',
  props: {
    tabLang: {},
    list: {},
    type: {},
    isHideSelect: { type: Boolean },
    maxLength: {}
  },
  emits: ["dragFile", "inputFileLink", "changeFile", "inputTextButton", "delete", "changeFlag", "switchRoles"],
  setup(__props: any, { emit: __emit }) {


const { t } = useI18n();

const dragOptions = {
  animation: 150,
  disabled: false,
  ghostClass: 'ghost',
  handle: '.handle-dnd',
};

const props = __props;

const emit = __emit;

const list = toRef(props, 'list');
const drag = ref(false);
const isLink = props.type === DocumentTypeEnum.Link;
const isImages = props.type === DocumentTypeEnum.Images;
const isVideo = props.type === DocumentTypeEnum.Video;
const isDocuments = props.type === DocumentTypeEnum.Document;
const isVideoOrDoc = isVideo || isDocuments;

const handleDragEnd = (event: { oldIndex: number, newIndex: number }) => {
  if (event.oldIndex === event.newIndex) {
    return;
  }
  emit('dragFile', reOrder(list.value));
  drag.value = false;
};
const handleLinkInput = (value: { index: number, value: string }) => {
  emit('inputFileLink', value);
};

const changeFile = (value: { data: UploadedPayloadType, index: number, indexLang: number }) => {
  emit('changeFile', value);
};

const handleTextButtonInput = (value: { index: number, value: string }) => {
  emit('inputTextButton', value);
};
const changeFlag = (value: { index: number, value: string }) => {
  emit('changeFlag', value);
};

const switchRoles = (value: { index: number, value: LinkRole[] }) => {
  emit('switchRoles', value);
};

const handleDelete = (value: number) => {
  emit('delete', value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(ElRow), {
      justify: "center",
      class: "general-table general-table__header-row"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(ElCol), {
          span: 1,
          class: "general-table__header-col"
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createElementVNode("div", { class: "general-table__header-title general-table__header-title_align-right" }, "   ", -1)
          ])),
          _: 1,
          __: [1]
        }),
        (_unref(isVideoOrDoc))
          ? (_openBlock(), _createBlock(_unref(ElCol), {
              key: 0,
              span: 2,
              class: "general-table__header-col"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)('labels.type')), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_unref(ElCol), {
          span: isImages ? 23 : 13,
          class: "general-table__header-col general-table__header-col_align-left"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('fields.url')), 1)
          ]),
          _: 1
        }, 8, ["span"]),
        isLink
          ? (_openBlock(), _createBlock(_unref(ElCol), {
              key: 1,
              span: 3,
              class: "general-table__header-col general-table__header-col_align-left"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('labels.access')), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (!isImages)
          ? (_openBlock(), _createBlock(_unref(ElCol), {
              key: 2,
              span: _unref(isVideoOrDoc) ? 8 : 7,
              class: "general-table__header-col"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('fields.caption')), 1)
              ]),
              _: 1
            }, 8, ["span"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_unref(draggable), _mergeProps({ list: list.value }, dragOptions, {
      itemKey: "hash",
      onStart: _cache[0] || (_cache[0] = ($event: any) => (drag.value = true)),
      onEnd: handleDragEnd
    }), {
      item: _withCtx(({ element, index }) => [
        (_openBlock(), _createElementBlock("div", {
          key: `instruction-${element.hash}`
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(element.locales, (localeMedia, indexLang) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: `row-${indexLang}`
            }, [
              (localeMedia.locale === _ctx.tabLang)
                ? (_openBlock(), _createBlock(GeneralTableRow, {
                    key: 0,
                    class: _normalizeClass(`local-${localeMedia.locale}`),
                    index: index,
                    indexLang: indexLang,
                    item: element,
                    localeMedia: localeMedia,
                    drag: drag.value,
                    type: _ctx.type,
                    isHideSelect: _ctx.isHideSelect,
                    maxLength: _ctx.maxLength,
                    onChangeFile: changeFile,
                    onInputFileLink: handleLinkInput,
                    onInputTextButton: handleTextButtonInput,
                    onChangeFlag: changeFlag,
                    onSwitchRoles: switchRoles,
                    onDelete: handleDelete
                  }, null, 8, ["class", "index", "indexLang", "item", "localeMedia", "drag", "type", "isHideSelect", "maxLength"]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ]))
      ]),
      _: 1
    }, 16, ["list"])
  ], 64))
}
}

})